export default function(map) {
  var keys = [];
  for (var key in map) keys.push(key);
  return keys;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-collection/src/keys.js
// module id = 1561
// module chunks = 3